import { createStore } from 'zustand/vanilla'

import { CoinTabConfig, defaultCoinTab } from '@/app/[locale]/price/_components/CoinsTable/configs'
import { devtoolsInNonProd } from '@/stores/utils'
import type { CoinSlug, LiveCoinMarket } from '@/types/coin'

export interface CoinsTableFilters {
  currentCoinTab: CoinTabConfig
  currentPage: number
}

export interface CoinsTableStoreState extends CoinsTableFilters {
  // Live coins market data from websocket message
  liveCoinsMarket: Record<CoinSlug, LiveCoinMarket>
}

interface CoinsTableStoreAction {
  updateFilters: (filters: Partial<CoinsTableFilters>) => void
  updateLiveCoinsMarket: (liveCoinsMarket: Record<CoinSlug, LiveCoinMarket>) => void
  clearLiveCoinsMarket: () => void
}

export type CoinsTableStore = CoinsTableStoreState & CoinsTableStoreAction

export const defaultInitialState: CoinsTableStoreState = {
  liveCoinsMarket: {},
  currentCoinTab: defaultCoinTab,
  currentPage: 1,
}

export const createCoinsTableStore = (initialState: CoinsTableStoreState = defaultInitialState) => {
  return createStore<CoinsTableStore>()(
    devtoolsInNonProd(
      set => ({
        ...initialState,
        clearLiveCoinsMarket: () => set({ liveCoinsMarket: {} }),
        updateFilters: filters => set(filters),
        updateLiveCoinsMarket: liveCoinsMarket => set({ liveCoinsMarket }),
      }),
      {
        name: 'CoinsTableStore',
      },
    ),
  )
}
